import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { pasteValue } from "../Reusable/OnPasteValue";
import EducationProvideList from "./EducationProviderList";
import { useFetch2 } from "components/utils/authenticatedHook";
import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import EducationMaterialSendToPatient from "./EducationMaterialSend";
import { deviceType } from "../../constants/general.constant.js";
import getDeviceType from "../../helpers/getDeviceTypeHelper.js";

function EducationMaterialDetails(props) {
    const { history } = props;
    const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
    const [sendModal, setSendModal] = useState(false);

    function handalToggleModal(event) {
        setSendModal(!sendModal);
        if (event == "reload") {
            getEducationProivdeDetials();
        }
    }

    useEffect(() => {
        getEducationProivdeDetials();
    }, []);

    function getEducationProivdeDetials(filter) {
        const query = {
            page: filter?.page ?? 1,
            limit: filter?.limit ?? 25,
            sortOrder: filter?.sortOrder ?? "desc",
            sortFiled: filter?.sortFiled ?? "createdAt",
            patientId: props?.patientId || ""
        };
        if (filter && filter.search) {
            query.search = filter.search;
        }
        doFetch({
            url: "/get-education-material-by-patient",
            method: "GET",
            disableWait: true,
            query: query,
        });
    }
    let debounceTimeout;
    function handleSearch(event) {
        const value = event.target.value;

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            getEducationProivdeDetials({ search: value });
        }, 500);
    }
    function paginationEducationList(type, { page, sizePerPage, filters, sortField, sortOrder }) {
        let data = { page: page, limit: sizePerPage };
        if (sortField) {
            data.sortFiled = sortField;
        }
        if (sortOrder) {
            data.sortOrder = sortOrder;
        }
        getEducationProivdeDetials(data);
    }
    const device = getDeviceType();
    return (
        <Row className="col-sm-12 main-cls-modal remove-table-padding mt-2">
            <Col sm="12" md={12} className="mt-12">
                    <div
                        className="row"
                        style={{ marginTop: "2%" }}
                    >
                    <div className={`col-sm-12 ${device === deviceType.tablet ? 'col-md-7' : 'col-md-9'}`}>
                        <input
                            type="text"
                            className={`form-control input-date-filter remove-bottom-margin mb-2 mr-3`}
                            id="exampleInputName1Test"
                            style={{ fontSize: "20px", flex: 1 }}
                            placeholder="Search material type, message, provide by..."
                            onChange={handleSearch} // Call handleChange on every input change
                            onPaste={(e) => {
                                e.preventDefault();
                                const event = pasteValue(e);
                                handleSearch(event);
                            }}
                        />
                    </div>
                    <div className={`col-sm-12 col-md-3 ${device === deviceType.mobile ? 'mt-2' : '' }`}>
                        <button
                            className="btn btn-gradient-success text-white"
                            onClick={() => {
                                setSendModal(true);
                            }}
                            style={{ borderRadius: '10px', paddingLeft: '15px', paddingRight: '15px' }}
                        >
                            <i className="mdi mdi-file-send-outline mr-1" style={{ fontSize: 17 }}></i> Send Educational Material
                        </button>
                    </div>
                    </div>
            </Col>
            <Col sm="12">
                <div className="w-100" style={{ marginTop: '20px' }}>
                    <EducationProvideList loading={isLoading} educationProvide={response && response.data ? response.data : {}} pagination={paginationEducationList} history={history} patientProfile={props.patientProfile}/>
                </div>
            </Col>
            {sendModal && (
                <EducationMaterialSendToPatient
                    sendModal={sendModal}
                    patientId={props?.patientId}
                    toggleModal={handalToggleModal}
                />
            )}
        </Row>
    )
}

export default withRouter(EducationMaterialDetails);
